// FaceReportStyles.js
export const styles = {
    container: {
        minHeight: 'auto',
        backgroundColor: '#0f172a',
        color: 'white',
        padding: 'clamp(0.75rem, 2.5vw, 1.5rem) clamp(0.75rem, 2vw, 1rem)',
        display: 'flex',
        justifyContent: 'center',
    },
    card: {
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        padding: 'clamp(1rem, 3vw, 2rem)',
        borderRadius: '24px',
        width: '100%',
        maxWidth: '800px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        gap: '1rem',
        marginBottom: '0.5rem',
    },
    integratedBadge: {
        background: 'rgba(52, 211, 153, 0.15)',
        color: '#34d399',
        padding: '0.4rem 0.8rem',
        borderRadius: '100px',
        fontSize: '0.85rem',
        fontWeight: 'bold',
        border: '1px solid rgba(52, 211, 153, 0.2)',
    },
    section: {
        marginBottom: '1rem',
        padding: 'clamp(0.9rem, 2.5vw, 1.25rem)',
        backgroundColor: 'rgba(255, 255, 255, 0.02)',
        borderRadius: '24px',
        border: '1px solid rgba(255, 255, 255, 0.03)',
        position: 'relative',
        overflow: 'hidden',
    },
    sectionTitle: {
        fontSize: '1.5rem',
        fontWeight: '800',
        marginBottom: '0.5rem',
        color: '#f8fafc',
    },
    sectionDesc: {
        fontSize: '0.95rem',
        color: '#94a3b8',
        marginBottom: '1rem',
    },
    subTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#cbd5e1',
        marginBottom: '1rem',
    },
    congruenceBox: {
        marginTop: '2rem',
        padding: '1.5rem',
        background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1))',
        borderRadius: '16px',
        textAlign: 'center',
        border: '1px solid rgba(255,255,255,0.05)',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.2rem',
    },
    integrationOffer: {
        marginBottom: '1rem',
        padding: 'clamp(1rem, 3vw, 1.5rem)',
        background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.05), rgba(139, 92, 246, 0.05))',
        borderRadius: '24px',
        textAlign: 'center',
        border: '1px solid rgba(236, 72, 153, 0.2)',
    },
    integrateBtn: {
        marginTop: '1.5rem',
        background: 'linear-gradient(90deg, #ec4899, #8b5cf6)',
        color: 'white',
        border: 'none',
        padding: '1rem 2rem',
        borderRadius: '12px',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 10px 15px -3px rgba(236, 72, 153, 0.3)',
    },
    backButton: {
        background: 'transparent',
        border: 'none',
        color: '#94a3b8',
        cursor: 'pointer',
        fontSize: '1rem',
        marginBottom: '0.5rem',
        display: 'flex',
        alignItems: 'center',
    },
    title: {
        fontSize: 'clamp(1.55rem, 6vw, 2.25rem)',
        fontWeight: '800',
        color: '#fff',
    },
    linkButton: {
        background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
        color: 'white',
        border: 'none',
        padding: '1.2rem 2.5rem',
        borderRadius: '16px',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 20px 25px -5px rgba(59, 130, 246, 0.2)',
    },
    personaCard: {
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        borderRadius: '20px',
        padding: '1.5rem',
        border: '1px solid rgba(255,255,255,0.1)',
        marginBottom: '2rem',
        textAlign: 'center',
    },
    personaTitle: {
        fontSize: '0.9rem',
        color: '#94a3b8',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: '1rem',
    },
    personaContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    personaBadgeContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '1rem',
        flexWrap: 'wrap',
        gap: '0.5rem',
    },
    personaBadge: {
        padding: '0.3rem 0.8rem',
        borderRadius: '8px',
        fontSize: '0.9rem',
        fontWeight: 'bold',
    },
    personaMainTitle: {
        fontSize: '1.8rem',
        fontWeight: '800',
        background: 'linear-gradient(90deg, #fce7f3, #e0f2fe)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        margin: '0.2rem 0 1rem 0',
    },
    personaKillerCopy: {
        fontSize: '1.1rem',
        color: '#fbcfe8',
        fontWeight: 'bold',
        marginBottom: '0.2rem',
        fontStyle: 'italic',
    },
    personaDesc: {
        fontSize: '1rem',
        color: '#cbd5e1',
        lineHeight: '1.6',
        maxWidth: '90%',
        margin: '0 auto 1.5rem auto',
    },
    flirtingTipBox: {
        background: 'rgba(236, 72, 153, 0.1)',
        border: '1px solid rgba(236, 72, 153, 0.2)',
        borderRadius: '12px',
        padding: '1rem',
        width: '100%',
        marginTop: '0.5rem',
        backdropFilter: 'blur(5px)',
    },
    bioSignalContainer: {
        width: '100%',
        background: 'rgba(0,0,0,0.2)',
        padding: '1rem',
        borderRadius: '12px',
        marginBottom: '1rem',
        textAlign: 'left'
    },
    bioTitle: {
        fontSize: '1rem',
        color: '#e2e8f0',
        marginBottom: '0.8rem',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        paddingBottom: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
    },
    bioRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.8rem',
        marginBottom: '1rem'
    },
    bioItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.3rem'
    },
    bioLabel: {
        fontSize: '0.85rem',
        color: '#94a3b8',
        fontWeight: 'bold'
    },
    bioBarBg: {
        width: '100%',
        height: '8px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '4px',
        overflow: 'hidden'
    },
    bioBarFill: {
        height: '100%',
        borderRadius: '4px'
    },
    bioDesc: {
        fontSize: '0.9rem',
        color: '#f472b6',
        fontStyle: 'italic',
        lineHeight: '1.4',
        margin: 0
    },
    approachContainer: {
        width: '100%',
        background: 'rgba(59, 130, 246, 0.1)',
        border: '1px solid rgba(59, 130, 246, 0.2)',
        padding: '1rem',
        borderRadius: '12px',
        marginBottom: '1rem',
        textAlign: 'left'
    },
    approachTitle: {
        fontSize: '1rem',
        color: '#93c5fd',
        marginBottom: '0.5rem',
        fontWeight: 'bold'
    },
    approachType: {
        fontSize: '1.2rem',
        fontWeight: '800',
        color: '#bfdbfe'
    },
    approachDesc: {
        fontSize: '0.9rem',
        color: '#cbd5e1',
        lineHeight: '1.5',
        margin: 0
    },
    breakdownContainer: {
        width: '100%',
        marginTop: '2rem',
        marginBottom: '2rem',
    },
    breakdownSubTitle: {
        fontSize: '0.95rem',
        color: '#94a3b8',
        marginBottom: '0.8rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        textAlign: 'left'
    },
    scoreRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '0.8rem',
    },
    scoreLabel: {
        width: '60px',
        fontSize: '0.9rem',
        color: '#cbd5e1',
        flexShrink: 0,
        textAlign: 'left'
    },
    scoreBarBg: {
        flex: 1,
        height: '8px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '4px',
        overflow: 'hidden'
    },
    scoreBarFill: {
        height: '100%',
        borderRadius: '4px',
        transition: 'width 1s ease-out'
    },
    scoreValue: {
        width: '40px',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        color: '#e2e8f0',
        textAlign: 'right'
    },
    analysisBox: {
        background: 'rgba(30, 41, 59, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        borderRadius: '16px',
        padding: '1.5rem',
        marginTop: '2rem',
        textAlign: 'left'
    },
    analysisTitle: {
        fontSize: '1.2rem',
        color: '#fff',
        marginBottom: '1.2rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontWeight: 'bold'
    },
    analysisText: {
        fontSize: '1rem',
        color: '#cbd5e1',
        lineHeight: '1.7',
        marginBottom: '1.2rem'
    },
    highlightText: {
        color: '#f472b6',
        fontWeight: 'bold',
        marginRight: '0.3rem'
    },
    actionPlanContainer: {
        marginTop: '2rem',
        paddingTop: '1.5rem',
        borderTop: '1px solid rgba(255,255,255,0.1)'
    },
    actionTitle: {
        fontSize: '1.1rem',
        color: '#fff',
        marginBottom: '1rem',
        fontWeight: 'bold'
    },
    actionBox: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem'
    },
    actionLabel: {
        display: 'block',
        fontSize: '0.9rem',
        color: '#94a3b8',
        marginBottom: '0.4rem',
        fontWeight: 'bold'
    },
    actionText: {
        fontSize: '0.95rem',
        color: '#e2e8f0',
        lineHeight: '1.5',
        margin: 0
    },
    evidenceContainer: {
        marginTop: '2rem',
        marginBottom: '2rem'
    },
    evidenceTitle: {
        color: '#fff',
        fontSize: '1.2rem',
        marginBottom: '0.5rem',
        textAlign: 'center'
    },
    evidenceSub: {
        color: '#94a3b8',
        fontSize: '0.9rem',
        textAlign: 'center',
        marginBottom: '1.5rem'
    },
    evidenceGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '1rem'
    },
    evidenceCard: {
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '12px',
        padding: '1.2rem',
        border: '1px solid rgba(255, 255, 255, 0.1)'
    },
    evidenceHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '0.8rem'
    },
    evidenceFeature: {
        color: '#e2e8f0',
        fontWeight: 'bold',
        fontSize: '0.95rem'
    },
    evidenceBadge: {
        padding: '0.2rem 0.6rem',
        borderRadius: '12px',
        fontSize: '0.75rem',
        fontWeight: 'bold'
    },
    evidenceDesc: {
        color: '#fff',
        fontSize: '1.1rem',
        margin: '0 0 0.5rem 0',
        fontWeight: 'bold'
    },
    evidenceComment: {
        color: '#cbd5e1',
        fontSize: '0.9rem',
        lineHeight: '1.5',
        margin: 0
    },
    premiumCard: {
        background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.6) 0%, rgba(15, 23, 42, 0.8) 100%)',
        backdropFilter: 'blur(20px)',
        borderRadius: '24px',
        padding: '2rem',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        marginBottom: '1.5rem',
        transition: 'all 0.3s ease',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    },
    twoColumnGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '1.5rem',
        marginBottom: '1.5rem',
    },
    actionPlanCard: {
        background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(5, 150, 105, 0.05) 100%)',
        backdropFilter: 'blur(20px)',
        borderRadius: '24px',
        padding: '2rem',
        border: '2px solid rgba(16, 185, 129, 0.3)',
        marginBottom: '1.5rem',
        boxShadow: '0 8px 32px rgba(16, 185, 129, 0.2)',
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1.5rem',
    },
    iconBadge: {
        width: '48px',
        height: '48px',
        borderRadius: '12px',
        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        flexShrink: 0,
        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    },
    cardTitle: {
        fontSize: '1.25rem',
        fontWeight: '700',
        color: '#f1f5f9',
        margin: 0,
        marginBottom: '0.25rem',
    },
    cardSubtitle: {
        fontSize: '0.875rem',
        color: '#94a3b8',
        margin: 0,
    },
    cardContent: {
        fontSize: '1rem',
        color: '#cbd5e1',
        lineHeight: '1.6',
        margin: 0,
    },
    lockOverlay: {
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        textShadow: '0 2px 4px rgba(0,0,0,0.5)',
        color: '#fff',
        zIndex: 5
    },
    unlockButton: {
        padding: '0.75rem 1.5rem',
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        fontSize: '0.9rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 12px rgba(245, 158, 11, 0.4)',
    },
    exportButton: {
        padding: '0.75rem 1.5rem',
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        fontSize: '0.9rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
    },
    paywallOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(to bottom, transparent 30%, rgba(15, 23, 42, 0.95))',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        padding: '2rem',
        zIndex: 20,
    },
    paywallContent: {
        textAlign: 'center',
        background: 'rgba(30, 41, 59, 0.8)',
        backdropFilter: 'blur(20px)',
        padding: '2rem',
        borderRadius: '24px',
        border: '1px solid rgba(255,255,255,0.1)',
        width: '100%',
        maxWidth: '400px',
    },
    unlockBtn: {
        padding: '0.75rem 1.5rem',
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        fontSize: '0.9rem',
        fontWeight: '600',
        cursor: 'pointer',
        marginTop: '1rem'
    },
    actionList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
    actionItem: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1rem',
        padding: '1rem',
        borderRadius: '12px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    actionNumber: {
        width: '24px',
        height: '24px',
        background: 'rgba(16, 185, 129, 0.2)',
        color: '#10b981',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.8rem',
        flexShrink: 0
    }
};

export const InjectAnimations = () => {
    if (typeof document !== 'undefined') {
        let styleEl = document.getElementById('face-report-animations');
        if (!styleEl) {
            styleEl = document.createElement("style");
            styleEl.id = 'face-report-animations';
            styleEl.innerText = `
                .unlock-animation {
                    animation: unlockFadeIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
                }
                @keyframes unlockFadeIn {
                    from { opacity: 0; transform: translateY(20px) scale(0.98); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }
                .face-detail-feed::-webkit-scrollbar {
                    display: none;
                }
                .face-mesh-card {
                    background: radial-gradient(circle at 20% 0%, rgba(45, 212, 191, 0.14), transparent 32%), linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(30, 41, 59, 0.92));
                    border: 1px solid rgba(148, 163, 184, 0.22);
                    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.36), inset 0 1px 0 rgba(255, 255, 255, 0.06);
                    border-radius: 20px;
                    padding: clamp(1rem, 3vw, 1.35rem);
                    overflow: hidden;
                }
                .face-mesh-card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: baseline;
                    gap: 0.85rem;
                    margin-bottom: 0.85rem;
                }
                .face-mesh-eyebrow {
                    color: #5eead4;
                    font-size: 0.74rem;
                    font-weight: 800;
                    letter-spacing: 0.08em;
                }
                .face-mesh-copy {
                    color: #dbeafe;
                    font-size: 0.9rem;
                    line-height: 1.5;
                    margin: 0;
                    text-align: right;
                }
                .face-mesh-grid {
                    display: grid;
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    gap: 0.75rem;
                }
                .face-mesh-figure {
                    position: relative;
                    min-width: 0;
                    margin: 0;
                    aspect-ratio: 1 / 1;
                    border-radius: 16px;
                    overflow: hidden;
                    background: rgba(2, 6, 23, 0.72);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                }
                .face-mesh-figure-accent {
                    border-color: rgba(94, 234, 212, 0.34);
                    box-shadow: inset 0 0 32px rgba(45, 212, 191, 0.08);
                }
                .face-mesh-label {
                    position: absolute;
                    left: 0.65rem;
                    top: 0.65rem;
                    z-index: 1;
                    padding: 0.34rem 0.55rem;
                    border-radius: 999px;
                    background: rgba(2, 6, 23, 0.68);
                    color: #f8fafc;
                    border: 1px solid rgba(255, 255, 255, 0.12);
                    font-size: 0.75rem;
                    font-weight: 800;
                    backdrop-filter: blur(10px);
                }
                .face-mesh-image {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                }
                @media (max-width: 640px) {
                    .face-mesh-card-header {
                        display: block;
                    }
                    .face-mesh-copy {
                        margin-top: 0.3rem;
                        text-align: left;
                    }
                    .face-mesh-grid {
                        grid-template-columns: 1fr;
                    }
                }
                html {
                   scroll-behavior: smooth;
                }
            `;
            document.head.appendChild(styleEl);
        }
    }
    return null;
};
